import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '../FormStyles/Button';
import { moveTilesToProof } from '../../lib/redux/actions.jsx';

const disabledTooltip = (tileCount, hasIncompleteTiles, hasFilters) => {
  if (tileCount === 0) {
    return 'Tile Digest is empty.';
  }

  if (hasIncompleteTiles) {
    return 'Tile Digest contains incomplete Tiles';
  }

  if (hasFilters) {
    return 'Remove filters before moving Tiles to Proof.';
  }

  return '';
};

const disabledClass = (tileCount, hasIncompleteTiles, hasFilters) =>
  tileCount === 0 || hasIncompleteTiles || hasFilters ? 'disabled' : '';

const MoveTileDigestToProofButton = ({
  bucket,
  hasIncompleteTiles,
  tileCount,
  moveTilesToProof,
  hasFilters,
}) => {
  const tooltip = disabledTooltip(tileCount, hasIncompleteTiles, hasFilters);
  const klass = disabledClass(tileCount, hasIncompleteTiles, hasFilters);
  const tilesIds = bucket.map(tile => tile.id);
  const onClick = useCallback(
    () => (tooltip ? null : moveTilesToProof(tilesIds)),
    [bucket, tooltip],
  );
  const { t } = useTranslation('edit');

  return (
    <div>
      <Button
        variant="containedBlue"
        padding="7px 16px"
        data-tip={tooltip}
        data-for="move_to_proof_tip"
        className={`new-proof-button js-new-proof-button ${klass}`}
        onClick={onClick}
      >
        {t('moveToProof')}
      </Button>
      <ReactTooltip
        place="top"
        type="error"
        effect="solid"
        id="move_to_proof_tip"
      />
    </div>
  );
};

MoveTileDigestToProofButton.propTypes = {
  bucket: PropTypes.array.isRequired,
  hasIncompleteTiles: PropTypes.bool,
  hasFilters: PropTypes.bool,
  tileCount: PropTypes.number,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  moveTilesToProof: tilesIds =>
    dispatch(moveTilesToProof(tilesIds, ownProps.bucketDate)),
});

export { MoveTileDigestToProofButton };

export default connect(null, mapDispatchToProps)(MoveTileDigestToProofButton);
